import { PartialPageSlugSchema } from '@/components/cms/schemas';
import { z } from 'zod';

export const rootSearchSchema = z.object({
  conversation_id: z.string().optional(),
  'agent-token': z.string().optional(),
  drawer: PartialPageSlugSchema.nullish(),
});

export type RootSearchSchema = z.infer<typeof rootSearchSchema>;
